'use client';

import { useRouter, useSearchParams, usePathname } from 'next/navigation';

const OPTIONS = [
  { value: '',           label: 'Featured'  },
  { value: 'newest',     label: 'Newest'    },
  { value: 'price-asc',  label: 'Price ↑'   },
  { value: 'price-desc', label: 'Price ↓'   },
  { value: 'name',       label: 'Name A–Z' },
];

export function SortDropdown() {
  const router       = useRouter();
  const pathname     = usePathname();
  const searchParams = useSearchParams();
  const current      = searchParams?.get('sort') ?? '';

  function onChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const v = e.target.value;
    const params = new URLSearchParams(searchParams?.toString() ?? '');
    if (v) params.set('sort', v);
    else params.delete('sort');
    router.push(`${pathname}?${params.toString()}`);
  }

  return (
    <div className="hidden md:flex items-center gap-3">
      <label htmlFor="np-sort" className="text-muted-strong">Sort</label>
      <select
        id="np-sort"
        aria-label="Sort products"
        value={current}
        onChange={onChange}
        className="bg-transparent border-none text-ink/70 hover:text-ink focus:outline-none cursor-pointer text-xs uppercase tracking-[0.12em]"
      >
        {OPTIONS.map((opt) => (
          <option key={opt.value || 'default'} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
}
